import MainView from 'js/views/main';
import { populateHiddenTimezoneField } from 'pmn/utils/signupEnhancements';

/**
 * Shows fallback if user is blocking google script specifically.
 * Fallback is rendered by `new.recaptcha.fallback.html.eex`.
 * There are two fallbacks, one wrapped by noscript, which is rendered
 * automatically, and the other which needs to be shown manually here, in
 * case google's specific script was unable to load.
 * */
const setupRecaptchaFallback = (): void => {
  const input = document.querySelector('[name="g-recaptcha-type"]');
  if (!input) {
    // no recaptcha hidden input means recaptcha is disabled
    return;
  }
  if ('__google_recaptcha_client' in window) {
    // prop present on window means recaptcha is enabled and has loaded
    return;
  }

  const fallback = document.getElementById('no-google');
  if (!fallback) {
    // should not happen, means fallback element is not rendered
    return;
  }

  // If we got here, recatpcha is enabled, but script failed to load,
  // so we show fallback
  (fallback as HTMLDivElement).style.display = 'initial';
};

export default class View extends MainView {
  mount(): void {
    super.mount();
    populateHiddenTimezoneField();
    setupRecaptchaFallback();
  }

  unmount(): void {
    super.unmount();
  }
}
